<div class="tab-content">
    <app-switch-input 
        [label]="'الإشعارات عبر البريد الإلكتروني'" 
        [labelEn] = "'status'"
        [labelDesc]="''"
        [value]= "value"
        (valueChanged) = "codeValueChanged($event)">
    </app-switch-input>
</div>